import React from 'react';
import { GridContainer, GridItem,  ImageButton } from '..';
import { Card, CardContent } from '@material-ui/core';
import { UpsellServiceImage } from '../../models/UpsellServiceImage';

interface IProps {
  onButtonClick?: (title: string) => React.MouseEventHandler<HTMLButtonElement> | undefined;
  items: UpsellServiceImage[];
}

export const UpsellItemCard: React.FC<IProps> = ({ 
    onButtonClick,
    items,
}) => {
  return (
    <GridItem xs={12}>
        <Card elevation={3}>
            <CardContent>
                <GridContainer spacing={2} direction="column" style={{padding: '15px' }}>                   
                    <GridItem xs={12}>
                        <GridContainer spacing={3}>
                            {items.map((item, index) => (
                            <GridItem key={index} xs={12} sm={6} md={4} lg={4}>
                                <ImageButton imageUrl={item.imageUrl} title={item.title} onClicked={onButtonClick?.(item.title)} style={{width: '100%'}} />
                            </GridItem>
                            ))}               
                        </GridContainer>
                    </GridItem>                
                </GridContainer>
            </CardContent>
        </Card>
    </GridItem>
  );
};
